import { render, staticRenderFns } from "./MyAskQuestion.vue?vue&type=template&id=725ee516&"
import script from "./MyAskQuestion.vue?vue&type=script&lang=js&"
export * from "./MyAskQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MyAskQuestion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports